( function ( $ ) {
	/**
	 *  CloneDisplayFieldSetting
	 *
	 *  Extra logic for this field setting
	 *
	 *  @date	18/4/18
	 *  @since	5.6.9
	 *
	 *  @param	void
	 *  @return	void
	 */

	var FlexibleContentLayoutFieldSetting = acf.FieldSetting.extend( {
		type: 'flexible_content',
		name: 'fc_layout',

		events: {
			'blur .layout-label': 'onChangeLabel',
			'click .add-layout': 'onClickAdd',
			'click .acf-field-settings-fc_head': 'onClickEdit',
			'click .acf-field-setting-fc-duplicate': 'onClickDuplicate',
			'click .acf-field-setting-fc-delete': 'onClickDelete',
			'changed:layoutLabel': 'updateLayoutTitles',
		},

		$input: function ( name ) {
			return $( '#' + this.getInputId() + '-' + name );
		},

		$list: function () {
			return this.$( '.acf-field-list:first' );
		},

		getInputId: function () {
			return (
				this.fieldObject.getInputId() +
				'-layouts-' +
				this.field.get( 'id' )
			);
		},

		// get all sub fields
		getFields: function () {
			return acf.getFieldObjects( { parent: this.$el } );
		},

		// get imediate children
		getChildren: function () {
			return acf.getFieldObjects( { list: this.$list() } );
		},

		initialize: function () {
			// add sortable
			var $tbody = this.$el.parent();
			if ( ! $tbody.hasClass( 'ui-sortable' ) ) {
				$tbody.sortable( {
					items: '> .acf-field-setting-fc_layout',
					handle: '.acf-fc_draggable',
					forceHelperSize: true,
					forcePlaceholderSize: true,
					scroll: true,
					stop: this.proxy( function ( event, ui ) {
						this.fieldObject.save();
					} ),
				} );
			}

			// add meta to sub fields
			this.updateFieldLayouts();
			this.updateLayoutTitles();
		},

		updateFieldLayouts: function () {
			this.getChildren().map( this.updateFieldLayout, this );
		},

		updateFieldLayout: function ( field ) {
			field.prop( 'parent_layout', this.get( 'id' ) );
		},

		updateLayoutTitles: function () {
			const label = this.get( 'layoutLabel' );

			const parentLabel = this.$el.find(
				'> .acf-label .acf-fc-layout-name'
			);
			const subFieldsLabel = this.$el.find(
				'> .acf-input > .acf-input-sub > .acf-sub-field-list-header > h3.acf-sub-field-list-title'
			);

			if ( label ) {
				parentLabel.html( ': ' + label );
				subFieldsLabel.html( acf.__( 'Fields' ) + ': ' + label );
			} else {
				parentLabel.html( '' );
				subFieldsLabel.html( acf.__( 'Fields' ) );
			}
		},

		onClickEdit: function ( e ) {
			const $target = $( e.target );

			if ( $target.hasClass( 'acf-btn' ) || $target.parent().hasClass( 'acf-btn' ) ) {
				return;
			}

			this.isOpen() ? this.close() : this.open();
		},

		isOpen: function ( e ) {
			const $settings = this.$el.children( '.acf-field-layout-settings' );
			return $settings.hasClass( 'open' );
		},

		open: function ( element, isAddingLayout ) {
			const $settings = element
				? element.children( '.acf-field-layout-settings' )
				: this.$el.children( '.acf-field-layout-settings' );
			const toggle = element
				? element.find( '.toggle-indicator' ).first()
				: this.$el.find( '.toggle-indicator' ).first();

			// action (show)
			acf.doAction( 'show', $settings );

			// open
			if ( isAddingLayout ) {
				$settings.slideDown( {
					complete: function () {
						$settings.find( '.layout-label' ).trigger( 'focus' );
					},
				} );
			} else {
				$settings.slideDown();
			}
			toggle.addClass( 'open' );
			if ( toggle.hasClass( 'closed' ) ) {
				toggle.removeClass( 'closed' );
			}
			$settings.addClass( 'open' );
		},

		close: function () {
			const $settings = this.$el.children( '.acf-field-layout-settings' );
			const toggle = this.$el.find( '.toggle-indicator' ).first();

			// close
			$settings.slideUp();
			$settings.removeClass( 'open' );
			toggle.removeClass( 'open' );
			if ( ! toggle.hasClass( 'closed' ) ) {
				toggle.addClass( 'closed' );
			}

			// action (hide)
			acf.doAction( 'hide', $settings );
		},

		onChangeLabel: function ( e, $el ) {
			var label = $el.val();

			this.set( 'layoutLabel', label );
			this.$el.attr( 'data-layout-label', label );

			var $name = this.$input( 'name' );

			// render name
			if ( $name.val() == '' ) {
				acf.val( $name, acf.strSanitize( label ) );
			}
		},

		onClickAdd: function ( e, $el ) {
			e.preventDefault();
			var prevKey = this.get( 'id' );
			var newKey = acf.uniqid( 'layout_' );

			// duplicate
			$layout = acf.duplicate( {
				$el: this.$el,
				search: prevKey,
				replace: newKey,
				after: function ( $el, $el2 ) {
					var $list = $el2.find( '.acf-field-list:first' );

					// remove sub fields
					$list.children( '.acf-field-object' ).remove();

					// show empty
					$list.addClass( '-empty' );

					// reset layout meta values
					$el2.attr( 'data-layout-label', '' );
					$el2.find( '.acf-fc-meta input' ).val( '' );
					$el2.find( '.acf-fc-layout-name' ).html( '' );
					$el2.find( '.acf-sub-field-list-title' ).html(
						acf.__( 'Fields ' )
					);
				},
			} );

			// get layout
			var layout = acf.getFieldSetting( $layout );

			// update hidden input
			layout.$input( 'key' ).val( newKey );
			! this.isOpen() ? this.open( layout.$el, true ) : layout.$el.find( '.layout-label' ).trigger( 'focus' );

			// save
			this.fieldObject.save();
		},

		onClickDuplicate: function ( e, $el ) {
			e.preventDefault();
			var prevKey = this.get( 'id' );
			var newKey = acf.uniqid( 'layout_' );

			// duplicate
			$layout = acf.duplicate( {
				$el: this.$el,
				search: prevKey,
				replace: newKey,
			} );

			// get all fields in new layout similar to fieldManager.onDuplicateField().
			// important to run field.wipe() before making any changes to the "parent_layout" prop
			// to ensure the correct input is modified.
			var children = acf.getFieldObjects( { parent: $layout } );
			if ( children.length ) {
				// loop
				children.map( function ( child ) {
					// wipe field
					child.wipe();

					// update parent
					child.updateParent();
				} );

				// action
				acf.doAction(
					'duplicate_field_objects',
					children,
					this.fieldObject,
					this.fieldObject
				);
			}

			// get layout
			var layout = acf.getFieldSetting( $layout );

			// update hidden input
			layout.$input( 'key' ).val( newKey );
			! this.isOpen() ? this.open( layout.$el, true ) : layout.$el.find( '.layout-label' ).trigger( 'focus' );
			// save
			this.fieldObject.save();
		},

		onClickDelete: function ( e, $el ) {
			e.preventDefault();
			// Bypass confirmation when holding down "shift" key.
			if ( e.shiftKey ) {
				return this.delete();
			}

			// add class
			this.$el.addClass( '-hover' );

			// add tooltip
			var tooltip = acf.newTooltip( {
				confirmRemove: true,
				target: $el,
				context: this,
				confirm: function () {
					this.delete();
				},
				cancel: function () {
					this.$el.removeClass( '-hover' );
				},
			} );
		},

		delete: function () {
			var $siblings = this.$el.siblings( '.acf-field-setting-fc_layout' );

			// validate
			if ( ! $siblings.length ) {
				alert(
					acf.__( 'Flexible Content requires at least 1 layout' )
				);
				return false;
			}

			// delete sub fields
			this.getFields().map( function ( child ) {
				child.delete( {
					animate: false,
				} );
			} );

			// remove tr
			acf.remove( this.$el );

			// save
			this.fieldObject.save();
		},
	} );

	acf.registerFieldSetting( FlexibleContentLayoutFieldSetting );

	/**
	 *  flexibleContentHelper
	 *
	 *  description
	 *
	 *  @date	19/4/18
	 *  @since	5.6.9
	 *
	 *  @param	type $var Description. Default.
	 *  @return	type Description.
	 */

	var flexibleContentHelper = new acf.Model( {
		actions: {
			sortstop_field_object: 'updateParentLayout',
			change_field_object_parent: 'updateParentLayout',
		},

		updateParentLayout: function ( fieldObject ) {
			var parent = fieldObject.getParent();

			// delete meta
			if ( ! parent || parent.prop( 'type' ) !== 'flexible_content' ) {
				fieldObject.prop( 'parent_layout', null );
				return;
			}

			// get layout
			var $layout = fieldObject.$el.closest(
				'.acf-field-setting-fc_layout'
			);
			var layout = acf.getFieldSetting( $layout );

			// check if previous prop exists
			// - if not, set prop to allow following code to trigger 'change' and save the field
			if ( ! fieldObject.has( 'parent_layout' ) ) {
				fieldObject.prop( 'parent_layout', 0 );
			}

			// update meta
			fieldObject.prop( 'parent_layout', layout.get( 'id' ) );
		},
	} );
} )( jQuery );
